import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { ViewUserProfileComponent } from "./view-user-profile/view-user-profile.component";
import { EditUserProfileComponent } from "./edit-user-profile/edit-user-profile.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { FillFormComponent } from "./fill-form/fill-form.component";
import { UserInFormsComponent } from "./usersinform/user-in-forms.component";
import { MultipeFormListComponent } from "./multipe-form-list/multipe-form-list.component";
import { EditUserMultipleFormComponent } from "./edit-user-multiple-form/edit-user-multiple-form.component";
import { UserResponseFormViewComponent } from "./user-response-form-view/user-response-form-view.component";
import { TabularViewComponent } from "./tabular-view/tabular-view.component";
import { FormAuditsComponent } from "./form-audits/form-audits.component";
import { HeaderSortComponent } from "./header-sort/header-sort.component";
import { CalendarReportComponent } from "./calendar-report/calendar-report.component";
import { NotificationPanelComponent } from "./notification-panel/notification-panel.component";
import { DynamicDashboardComponent } from "./dynamic-dashboard/dynamic-dashboard.component";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("../main/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "tuft-dashboard",
        loadChildren: () =>
          import("../main/tuft-dashboard/tuft-dashboard.module").then((m) => m.TuftDashboardModule),
      },
      {
        path: "forms-data",
        loadChildren: () =>
          import("../main/forms-table-data/forms-table-data.module").then((m) => m.FormsTableDataModule),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting/setting.module").then((m) => m.SettingModule),
      },
      {
        path: "circles",
        loadChildren: () =>
          import("../main/circles/circles.module").then((m) => m.CirclesModule),
      },
      {
        path: "connection",
        loadChildren: () =>
          import("../main/connection/connection.module").then((m) => m.ConnectionModule),
      },
      {
        path: "polling",
        loadChildren: () =>
          import("../main/polling-management/polling-management.module").then((m) => m.PollingManagementModule),
      },
    
      {
        path: "user-profile",
      component:ViewUserProfileComponent
      },
      {
        path: "change-password",
      component:ChangePasswordComponent
      },
      {
        path: "user-profile-edit",
      component:EditUserProfileComponent
      },
      {
        path: "fill-form",
      component:FillFormComponent
      },
      {
        path: "user-in-forms",
      component:UserInFormsComponent
      },
      {
        path: "user-response-form-view",
      component:UserResponseFormViewComponent
      },
      {
        path: "multiple-form-list",
      component:MultipeFormListComponent
      },
      {
        path: "edit-user-multiple-form",
      component:EditUserMultipleFormComponent
      },
      {
        path: "tabular-view",
      component:TabularViewComponent
      },
      {
        path: "forms-audit",
      component:FormAuditsComponent
      },
      {
        path: "header-sort",
      component:HeaderSortComponent
      },
      {
        path: "calendar-report",
      component:CalendarReportComponent
      },
      {
        path: "notification-panel",
      component:NotificationPanelComponent
      },
      {
        path: "dynamic-dashboard",
        component: DynamicDashboardComponent
      },
      // {
      //   path: "manager",
      //   loadChildren: () =>
      //     import("./manager/manager-management.module").then((m) => m.ManagerManagementModule),
      //     data: { state: 'manager' } 
      // },
      // {
      //   path: "employee",
      //   loadChildren: () =>
      //     import("./employees/employee.module").then((m) => m.EmployeeModule),
      //     data: { state: 'employee' } 
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
